import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.User;
export const entityOperations = [
  Operation.getAll,
];
